import { computed } from "vue";
import { useStore } from "vuex";

import type { RootState } from "@/store/types";

export function useTheme() {
    const store = useStore<RootState>();

    const theme = computed<string>(() => store.state.ui.theme);

    const themeClassName = computed(() => {
        return `theme theme-${theme.value}`;
    }).value;

    return {
        theme,
        themeClassName
    };
}
